<template>
  <el-row :gutter="20">
    <h3 class="module-title">平台资源</h3>
    <!-- <el-col :span="4" v-for="(item,index) in imgs" :key="index">
      <div class="customer">
        <img :src="item" alt />
      </div>
    </el-col>-->
    <el-row :gutter="20" style="margin: 50px 0 0 0">
      <el-col :span="6" v-for="(item, index) in innwerData4" :key="index">
        <div class="innerbox2">
          <a :href="item.url" target="_blank">
            <div class="innerbox2-icon">
              <i class="iconfont" :class="item.icon"></i>
            </div>
            <div class="innerbox2-text">
              <h4 class="innerbox2-title">{{ item.title }}</h4>
              <h5 class="innerbox2-subtitle">{{ item.subtitle }}</h5>
            </div>
          </a>
        </div>
      </el-col>
    </el-row>
    <!--  <el-tabs
      class="custTab"
      v-model="activeName"
      @tab-click="handleClick"
      stretch
    >
      <el-tab-pane label="知识库" name="tab1">
       
      </el-tab-pane>
     <el-tab-pane label="系统演示" name="tab2">
        <el-row :gutter="20" style="margin: 50px 0 0 0">
          <el-col :span="6" v-for="(item, index) in innwerData1" :key="index">
            <div class="innerbox2">
              <a :href="item.href" target="_blank">
                <div class="innerbox2-icon">
                  <i class="iconfont" :class="item.icon"></i>
                </div>
                <div class="innerbox2-text">
                  <h4 class="innerbox2-title">{{ item.title }}</h4>
                  <h5 class="innerbox2-subtitle">{{ item.subtitle }}</h5>
                </div>
              </a>
            </div>
          </el-col>
        </el-row>
      </el-tab-pane>
      <el-tab-pane label="样式模板" name="tab3">
        <el-row :gutter="20" style="margin: 50px 0 0 0">
          <el-col :span="6" v-for="(item, index) in innwerData3" :key="index">
            <div class="innerbox2">
              <a :href="item.href" target="_blank">
                <div class="innerbox2-icon">
                  <i class="iconfont" :class="item.icon"></i>
                </div>
                <div class="innerbox2-text">
                  <h4 class="innerbox2-title">{{ item.title }}</h4>
                  <h5 class="innerbox2-subtitle">{{ item.subtitle }}</h5>
                </div>
              </a>
            </div>
          </el-col>
        </el-row>
      </el-tab-pane>
       <el-tab-pane label="知识库" name="tab4">
        <el-row :gutter="20" style="margin: 50px 0 0 0">
          <el-col :span="6" v-for="(item, index) in innwerData4" :key="index">
            <div class="innerbox2">
              <a :href="item.href" target="_blank">
                <div class="innerbox2-icon">
                  <i class="iconfont" :class="item.icon"></i>
                </div>
                <div class="innerbox2-text">
                  <h4 class="innerbox2-title">{{ item.title }}</h4>
                  <h5 class="innerbox2-subtitle">{{ item.subtitle }}</h5>
                </div>
              </a>
            </div>
          </el-col>
        </el-row>
      </el-tab-pane> 
      <el-tab-pane label="应用下载" name="tab5">
        <el-row :gutter="20" style="margin: 50px 0 0 0">
          <el-col :span="6" v-for="(item, index) in innwerData5" :key="index">
            <div class="innerbox2">
              <a :href="item.href" target="_blank">
                <div class="innerbox2-icon">
                  <i class="iconfont" :class="item.icon"></i>
                </div>
                <div class="innerbox2-text">
                  <h4 class="innerbox2-title">{{ item.title }}</h4>
                  <h5 class="innerbox2-subtitle">{{ item.subtitle }}</h5>
                </div>
              </a>
            </div>
          </el-col>
        </el-row>
      </el-tab-pane>
    </el-tabs> -->
  </el-row>
</template>

<script>
import { doserve, formatData } from "@/assets/js/serverUtils.js";

export default {
  name: "product",
  props: {
    msg: String,
  },
  data() {
    return {
      activeName: "tab1",
      innwerData2: [
        {
          title: "app配置工具",
          icon: "icon-yingyongchengxu",
          subtitle: "账号：demo 密码：123456",
          href: "http://fx-designer.feixuns.com/index.html#/",
        },
        {
          title: "在线WWW",
          icon: "icon-anzhuo",
          subtitle: "",
          href: "http://sx.app.feixuns.com/www/pcmain.html",
        },

        {
          title: "飞讯图标库",
          icon: "icon-wuliaotianchong",
          subtitle: "",
          href: "http://demo.feixuns.com/frontend/fsiconfont/demo_index.html",
        },
      ],
      innwerData3: [
        {
          title: "看板样式库",
          icon: "icon-ai13",
          subtitle: "",
          href: "https://feixuns.yuque.com/books/share/b171cb9b-b6f8-45cd-9b05-464687ab26a3",
        },
        {
          title: "派工电脑/平板样式库",
          icon: "icon-baobiaofenxi-copy",
          subtitle: "",
          href: "https://feixuns.yuque.com/books/share/b171cb9b-b6f8-45cd-9b05-464687ab26a3",
        },
      ],
      innwerData4: [
        {
          title: "数字看板演示",
          icon: "icon-ai13",
          subtitle: "",
          href: "http://lookboard.feixuns.com",
        },
        {
          title: "APP操作文档",
          icon: "icon-shuoming",
          subtitle: "",
          href: "https://hzfeixuns.yuque.com/staff-rzu8e4/rmwx9k?# 《新版APP操作手册》",
        },
        {
          title: "BS操作文档",
          icon: "icon-ai13",
          subtitle: "",
          href: "https://hzfeixuns.yuque.com/staff-rzu8e4/ni582k?# 《BS平台操作手册》",
        },
        {
          title: "CS操作文档",
          icon: "icon-yingyongchengxu",
          subtitle: "",
          href: "https://www.kancloud.cn/fesion/erp_cs/1803508",
        },
        // {
        //   title: "APP学习演示",
        //   icon: "icon-shouji",
        //   subtitle: "",
        //   href: "http://demo.feixuns.com/appDemo/pcmain.html",
        // },

        {
          title: "APP样式库",
          icon: "icon-appdownload",
          subtitle: "",
          href: "https://hzfeixuns.yuque.com/staff-rzu8e4/rl1x2i?# 《APP样式库》",
        },
        {
          title: "智企互联下载",
          icon: "icon-xiazai",
          subtitle: "",
          href: "https://hzfeixuns.yuque.com/staff-rzu8e4/inwiyy/xwiqoo9i1gkmmrvn?singleDoc# 《1.平台工具》",
        },
        {
          title: "视频软件(密码：feixun)",
          icon: "icon-shipin1",
          subtitle: "",
          href: "https://share.weiyun.com/5sZRe7E",
        },
      ],
      innwerData5: [],
    };
  },
  methods: {
    handleClick(tab, event) {
      console.log(tab, event);
    },
  },
  mounted() {
    (async () => {
      let res = await doserve("8999-1");
      // debugger;
      console.log("服务返回数据", formatData(res));
      this.innwerData4 = formatData(res).filter((item) => {
        return item.show === 1;
      });
      //debugger;
    })();
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.module-title {
  text-align: center;
}
.custTab >>> .el-tabs__nav-wrap::after {
  opacity: 0;
}
.custTab >>> .el-tabs__nav-wrap {
  width: 600px;
  margin: 0 auto;
}
.custTab >>> .el-tabs__item {
  font-size: 18px;
}
</style>
